import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "message_div" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tabbar = _resolveComponent("tabbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", {
        frameborder: "0",
        scrolling: "auto",
        src: $setup.iframe_url
      }, null, 8, _hoisted_2)
    ]),
    _createVNode(_component_tabbar, { active: $setup.tabbar_index }, null, 8, ["active"])
  ], 64))
}